<div class="excel-to-dxgrid">
    <div class="file-uploader-container">
        <dx-file-uploader selectButtonText="Upload Budget/EFC" labelText="" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
            uploadMode="instantly" (onValueChanged)="onValueChanged($event)">
        </dx-file-uploader>
    </div>
    <dx-popup [width]="'80%'" [height]="'90%'" [showTitle]="true" title="Upload Budget/EFC" [dragEnabled]="false"
        [hideOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="excelPopupVisible" 
        (onHiding)="onHiding($event)">
        <div *dxTemplate="let data of 'content'">
            <dx-data-grid #exceltodxgrid id="exceltodxgrid" [dataSource]="excelData2" [columns]="columnDataFields" width="100%" style="height: calc(100% - 30px);" class="pt3 pb3" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                [hoverStateEnabled]="true" [rowAlternationEnabled]="true" [columnAutoWidth]="true" [allowColumnReordering]="true">
                <dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
                <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[25, 50, 100]" [showInfo]="true"
                    [showNavigationButtons]="true" [displayMode]="'full'">
                </dxo-pager>
                <dxo-editing mode="batch" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true" [useIcons]="true"
                    [selectTextOnEditStart]="true" [startEditAction]="'click'"> </dxo-editing>
                <dxo-filter-row visible="true" [applyFilter]="'auto'"></dxo-filter-row>
                <dxo-header-filter visible="true" [allowSearch]="true"></dxo-header-filter>
                <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
                <dxo-selection selectAllMode="allPages" showCheckBoxesMode="always" mode="multiple"></dxo-selection>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Project List"></dxo-export>
                <dxo-scrolling mode="standard" [showScrollbar]="'always'"></dxo-scrolling>
                <dxi-column type="selection" width="30"></dxi-column>
            </dx-data-grid>
            <div class="flex justify-center">
                <div>
                    <dx-button text="Save" (onClick)="save($event)"></dx-button>
                </div>
            </div>
        </div>
    </dx-popup>
    
</div>